import { Box, Button, Divider, Grid, Paper, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Anomalias, IReportsRise } from '../../../../services/api/reports/ReportsServicesRise';
import { Remove, Add } from '@mui/icons-material';

interface AssessementAnomaliesProps {
    dataRise?: IReportsRise;
    onDataChange: (data: Anomalias[]) => void;
}

export const AssessementAnomaliesRise = ({dataRise, onDataChange}: AssessementAnomaliesProps) => {
    
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const [data, setData] = useState<Anomalias[]>(dataRise?.anomalias || [{ anomalia: '', avaliacao: '' }]);

    useEffect(() => {
        if (dataRise?.anomalias && Object.keys(dataRise.anomalias).length > 0) {
            setData(dataRise.anomalias);
        }
    }, [dataRise]);


    const handleAdd = () => {
        const newItem: Anomalias = { anomalia: '', avaliacao: '' };
        setData(prevDataSteps => [...prevDataSteps, newItem]);
    };

    const handleRemove = () => {
        if (data.length > 1) {
            setData(prevDataSteps => prevDataSteps.slice(0, -1));
        }
    };

    const handleAnomaliasChange = (index: number, fieldName: keyof Anomalias, value: string) => {
        const updatedData = [...data];
        updatedData[index][fieldName] = value;
        setData(updatedData);
        onDataChange(updatedData);
    };

    return (
        <Box>
            <Box padding={1}>
                <Grid container>
                    <Grid item xs={12} marginBottom={1}>
                        <Typography variant='h5'>Avaliação das anomalias</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={handleRemove}
                            disabled={data.length <= 1} 
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                {data.map((item, index) => (
                    <Box key={index} padding={1}>
                        <Box padding={1} component={Paper} variant='outlined' sx={{ borderRadius: '20px' }}>
                            <Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            label='Anomalia'
                                            value={item.anomalia}
                                            id='anomalia'
                                            fullWidth
                                            onChange={(e) => handleAnomaliasChange(index, 'anomalia', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            label='Avaliação'
                                            value={item.avaliacao}
                                            id='avaliacao'
                                            fullWidth
                                            onChange={(e) => handleAnomaliasChange(index, 'avaliacao', e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
